import { useState } from "react";
import Skeleton from "react-loading-skeleton";

import { useGetMarketerReferedList } from "../../../lib/queries/queriesAndMutations";
import Pagination from "../../Pagination";
import UserRow from "./cards/UserRow";
const pageSize = 20;

const MarketerRefferedUsers = () => {
  const [currentPage, setCurrentPage] = useState(1);

  const onPageChange = (page) => setCurrentPage(page);

  const { data: users, isPending } = useGetMarketerReferedList({
    currentPage,
    pageSize,
  });

  const list = users?.data?.items;
  const hasData = users?.data?.count > 0;

  if (isPending) {
    return <PageSkeletonLoader />;
  }

  return (
    <div className="w-full p-1 md:p-2 h-full flex flex-col  overflow-hidden  ">
      <div className=" overflow-auto   h-full  ">
        {hasData ? (
          <div className="mx-auto ">
            <table className=" mt-6 overflow-hidden rounded-xl border border-neutral-200 bg-white shadow-sm  w-fit mx-auto">
              <thead className="bg-neutral-20">
                <tr className="h-14">
                  <th className="px-6 text-center text-sm font-semibold text-neutral-700">
                    کاربر زیرمجموعه{" "}
                  </th>
                  <th className="px-6 text-center text-sm font-semibold text-neutral-700">موبایل</th>
                </tr>
              </thead>
              <tbody>
                {list.map((user, index) => {
                  return <UserRow user={user} />;
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex flex-col min-h-[300px]  m-auto justify-center items-center gap-6">
            <div className="bg-neutral-10 flex flex-col items-center p-6 rounded-md">
              <img src="/images/folder-empty.svg" alt="" className="max-w-[40px] max-h-[40px]" />
              <p> کاربر معرفی شده ای وجود ندارد!</p>
            </div>
          </div>
        )}
      </div>
      <div className="w-full bg-neutral-10 rounded-v-lg mt-2">
        <Pagination
          onPageChange={onPageChange}
          totalCount={users?.data?.count || 0}
          siblingCount={1}
          currentPage={currentPage}
          pageSize={pageSize}
          className="bg-primary-40"
        />
      </div>
    </div>
  );
};

export default MarketerRefferedUsers;

const PageSkeletonLoader = () => {
  const array = new Array(20).fill(null).map((u, i) => i);

  return (
    <div className="my-8 p-1 md:p-2 h-full flex flex-col  overflow-hidden  gap-2 w-fit mx-auto">
      {array.map((_, i) => {
        return (
          <div key={i} className="w-[400px] h-10 ">
            <Skeleton className="h-full" />
          </div>
        );
      })}
    </div>
  );
};
